import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import AccountsReport from "../components/accountsReport.jsx";
import Footer from "../components/footer.jsx";

function AccountsReportpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <AccountsReport/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default AccountsReportpage;
